import { Controller, useFormContext } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';
import { PinInput, Select, TextInput } from '@gravity-ui/uikit';

import { CHOOSE, DOING, DOMEN, MKF, PREFICS, SATISFACTION } from '../../constants';

import styles from './styles.module.scss';

interface ProblemAssessmentFormProps {
	index: number;
	problemId?: number;
	problemText: string;
	problemImportance: number;
}

interface ProblemFields {
	execution: number | '';
	satisfaction: number | '';
	// prefix: string[];
	// domainCode: string[];
	problemId?: number;
}

interface StepThreeFormData {
	goal: string;
	goalPlan: string;
	estimateHistories: ProblemFields[];
	createdBlankAt?: string;
}

export const ProblemAssessmentForm = ({ index, problemText, problemImportance }: ProblemAssessmentFormProps) => {
	const {
		register,
		control,

		formState: { isSubmitted, errors },
	} = useFormContext<StepThreeFormData>();

	return (
		<div className={`${styles.block} ${styles.problem_description}`}>
			<div className={styles.block__problem}>
				<h3>{problemImportance}.</h3>
				<p className={styles.block__problem__problem_text}>{problemText}</p>
			</div>
			<div className={styles.block__rows}>
				<FormRow label={DOING} className={`${styles.row} ${styles.short}`} required>
					<TextInput
						size="xl"
						hasClear
						type="text"
						{...register(`estimateHistories.${index}.execution`, { required: true })}
						validationState={
							isSubmitted && errors.estimateHistories?.[index]?.execution ? 'invalid' : undefined
						}
						errorPlacement="inside"
						errorMessage={
							isSubmitted && errors.estimateHistories?.[index]?.execution
								? 'Обязательно для заполнения'
								: undefined
						}
					/>
				</FormRow>
				<FormRow label={SATISFACTION} className={`${styles.row} ${styles.short}`} required>
					<TextInput
						size="xl"
						hasClear
						type="text"
						{...register(`estimateHistories.${index}.satisfaction`, { required: true })}
						validationState={
							isSubmitted && errors.estimateHistories?.[index]?.satisfaction ? 'invalid' : undefined
						}
						errorPlacement="inside"
						errorMessage={
							isSubmitted && errors.estimateHistories?.[index]?.satisfaction
								? 'Обязательно для заполнения'
								: undefined
						}
					/>
				</FormRow>
				{/* <h4>{MKF}</h4>
				<FormRow label={PREFICS} className={`${styles.row} ${styles.mkf}`} required>
					<Controller
						name={`estimateHistories.${index}.prefix`}
						control={control}
						render={({ field }) => (
							<Select
								className={styles.row__select}
								size="xl"
								hasClear
								placeholder={CHOOSE}
								value={field.value}
								onUpdate={(value) => {
									field.onChange(value);
								}}
								validationState={
									isSubmitted && errors.estimateHistories?.[index]?.prefix ? 'invalid' : undefined
								}
								errorPlacement="inside"
								errorMessage={
									isSubmitted && errors.estimateHistories?.[index]?.prefix
										? 'Обязательно для заполнения'
										: undefined
								}
							>
								<Select.Option value="B">B</Select.Option>
								<Select.Option value="C">C</Select.Option>
								<Select.Option value="D">D</Select.Option>
								<Select.Option value="E">E</Select.Option>
							</Select>
						)}
					/>
				</FormRow>
				<FormRow label={DOMEN} className={`${styles.row} ${styles.mkf}`} required>
					<Controller
						name={`estimateHistories.${index}.domainCode`}
						control={control}
						render={({ field }) => (
							<PinInput
								type="alphanumeric"
								size="xl"
								value={field.value}
								onUpdate={(value: string[]) => {
									field.onChange(value);
								}}
								validationState={
									isSubmitted && errors.estimateHistories?.[index]?.domainCode ? 'invalid' : undefined
								}
								errorMessage={
									isSubmitted && errors.estimateHistories?.[index]?.domainCode
										? 'Обязательно для заполнения'
										: undefined
								}
							/>
						)}
					/>
				</FormRow> */}
			</div>
		</div>
	);
};
